import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';

const Footer = () => {
  const footerLinks = {
    'Quick Links': [
      { label: 'About Us', path: '/about' },
      { label: 'Medicines', path: '/medicines' },
      { label: 'Practitioners', path: '/practitioners' },
      { label: 'Book Appointment', path: '/book-appointment' }
    ],
    'Support': [
      { label: 'Contact Us', path: '/contact' },
      { label: 'Return Policy', path: '/return-policy' },
      { label: 'FAQs', path: '/faqs' },
      { label: 'Privacy Policy', path: '/privacy' }
    ]
  };

  return (
    <footer className="bg-primary/5 border-t border-border mt-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center space-x-2 group">
              <motion.img
                whileHover={{ rotate: 360 }}
                transition={{ duration: 0.6 }}
                src="/logo-mark.png"
                alt="Aatreya Herbals logo"
                className="w-11 h-11 rounded-full object-cover border border-border bg-white shadow-sm"
              />
              <span className="text-2xl font-bold text-foreground font-serif">
                Aatreya Herbals
              </span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Experience the ancient wisdom of Ayurveda with modern convenience. Natural healing for mind, body, and soul.
            </p>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="font-serif font-semibold text-lg mb-6">{title}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-muted-foreground hover:text-primary transition-colors text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact */}
          <div>
            <h3 className="font-serif font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-muted-foreground text-sm">
                  Aatreya Herbals,<br />Saharanpur, Uttar Pradesh
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                <a href="tel:+918279765078" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  +91 8279765078
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                <a href="mailto:aatreyaherbals@gmail.com" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  aatreyaherbals@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <p className="text-muted-foreground text-sm">
            © {new Date().getFullYear()} Aatreya Herbals. All rights reserved.
          </p>
          <p className="text-muted-foreground text-sm">
            Made with ❤️ for holistic wellness
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;